import { z } from "zod";
import { confirmableConfig, confirmableDefaults } from "./confirmable.js";
import { optionalUnlessRequired, requiredText, type FieldDescriptor } from "./types.js";

const configSchema = z.object({
  ...confirmableConfig,
  /**
   * Key of another field this one must equal — the "Confirm account number" / "Confirm NIN"
   * pattern. Checked in `buildFormValidator`, so the browser and the server enforce it from the
   * same place. A mistyped account number is not a cosmetic error: it sends a stipend to a
   * stranger.
   */
  mustMatchKey: z.string().max(100).optional(),
  minLength: z.number().int().nonnegative().optional(),
  maxLength: z.number().int().positive().max(10_000).default(255),
});

export const textSingleField: FieldDescriptor<z.infer<typeof configSchema>> = {
  type: "text_single",
  label: "Short text",
  category: "text",
  icon: "Type",
  configSchema,
  valueSchema: (config, isRequired) => {
    let schema = isRequired ? requiredText() : z.string().trim();
    if (config.minLength !== undefined) schema = schema.min(config.minLength);
    schema = schema.max(config.maxLength);
    return optionalUnlessRequired(schema, isRequired);
  },
  defaultConfig: { ...confirmableDefaults, maxLength: 255 },
  supportsProfileBinding: true,
  defaultSearchable: true,
  renderHints: {},
};
